export default __webpack_public_path__ + "static/media/01.5e03a229.jpg";